import {
  Box,
  Card,
  CardContent,
  Paper,
  Rating,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BookInfoCard from "shared/components/bookInfoCard";
import { toastMessage } from "shared/components/toast";
import { getBookDetailsService } from "shared/services/general";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { getRecentHistoryBookReviewer } from "shared/services/bookReviewerService";
import { getBookHistoryService } from "shared/services/hodService";
import moment from "moment";
import CheckIcon from "@mui/icons-material/Check";
import PaginationComponent from "shared/components/pagination";
import SkeletonLoader from "./skeletonLoader";
// import { LastPage } from "@mui/icons-material";
import { Icons } from "assets";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";
import { rolesRoutes } from "shared/routes/allRoutes";
import { getRevisionHistoryByProductManager } from "shared/services/productManagerService";
import { roles } from "shared/utils/constants";

function BookRevisions() {
  const { id } = useParams<{ id: string }>() as { id: string };
  const { user } = useSelector((state: any) => state.root);
  const [bookDetail, setBookDetail] = useState<any>(null);
  const [bookDetailLoader, setBookDetailLoader] = useState<boolean>(false);
  const [history, setHistory] = useState<any>(null);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [activePage, setActivePage] = useState<number>(1);
  const [loader, setLoader] = useState<boolean>(false);

 

  const getBookHistory = () => {
    setLoader(true);

    let service =
      Number(user?.role?.role_id) === roles.bookReviewer
        ? getRecentHistoryBookReviewer
        : Number(user?.role?.role_id) === roles.productManager
        ? getRevisionHistoryByProductManager
        : getBookHistoryService;

    service(bookDetail ? bookDetail?.id : null, activePage)
      .then(({ data }) => {
        setHistory(data?.data?.data);
        setTotalPage(data?.data?.last_page);
        setLoader(false);
      })
      .catch((error) => {
        toastMessage("error", error?.response?.data?.message);
        console.log("error", error?.response?.data?.message);
        setLoader(false);
      });
  };

  useEffect(() => {
    if (bookDetail) {
      getBookHistory();
    }
    // eslint-disable-next-line
  }, [bookDetail, activePage]);

  const getBookDetails = () => {
    setBookDetailLoader(true);
    getBookDetailsService(id)
      .then(({ data }) => {
        setBookDetail(data?.data);
        setBookDetailLoader(false);
      })
      .catch((err) => {
        toastMessage("error", err?.response?.data?.message);
        console.log("err", err?.response?.data?.message);
        setBookDetailLoader(false);
      });
  };

  useEffect(() => {
    getBookDetails();
    // eslint-disable-next-line
  }, [id]);

  useBreadcrumbs(
    {
      title: "Book Revision",
      path: routeConstant.bookRevisions.path.replace(":id", id),
    },
    true
  );

  return (
    <div>
      <Card>
        <CardContent>
          <BookInfoCard book={bookDetail} loader={bookDetailLoader} />
          
          {history?.length === 0 ? (
            <div>
              <div className={styles.noUserCard}>
                <Icons.NoDataIcon />
                <h5>No Revisions Found</h5>
              </div>
            </div>
          ) : (
            history?.map((item: any, inx: any) => {
              return (
                <Box marginTop={"20px"}>
                  <div className={styles.headingContainer}>
                    <div className={styles.title}>
                      <span className={styles.dot}>&#x2022;</span>
                      Book Revision {totalPage - (activePage - 1)}
                    </div>
                    <div className={styles.time}>
                      <span style={{ marginRight: "5px" }}>
                        {moment(item?.created_at).format("DD-MM-YYYY | H:SS A")}
                      </span>
                    </div>
                  </div>

                  <div className={styles.revisionDescription}>
                    <div>
                      {item?.response && (
                        <div className={styles.replySection}>
                          <div style={{ fontSize: "16px", fontWeight: "500" }}>
                            Publisher response:
                          </div>
                          <div className={styles.repliedText}>
                            {item?.response}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <TableContainer component={Paper} className={styles.table}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow className={styles.tableHead}>
                          <TableCell>Parameter</TableCell>
                          <TableCell>Response</TableCell>
                          <TableCell>Comments</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {loader ? (
                          <SkeletonLoader />
                        ) : (
                          //role 3 is for book reviewer.
                          user?.role?.role_id !== 3 &&
                          item?.data?.intial_review &&
                          Object.keys(item?.data?.intial_review)
                            .map((key) => item?.data?.intial_review[key])
                            ?.map((itm: any) => {
                              return (
                                <TableRow>
                                  <TableCell>{itm?.label}</TableCell>
                                  <TableCell>
                                    {itm?.type === "rating" ? (
                                      <Rating
                                        name="simple-controlled"
                                        value={itm?.value}
                                        readOnly
                                      />
                                    ) : Number(itm?.option) === 0 ? (
                                      "No"
                                    ) : (
                                      "Yes"
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {itm?.type === "checklist" &&
                                      itm?.options?.map((itms: any) => {
                                        return (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            {itms?.value && (
                                              <>
                                                <CheckIcon
                                                  style={{ fill: "#9A469B" }}
                                                />{" "}
                                                <span
                                                  style={{ marginLeft: "10px" }}
                                                >
                                                  {itms?.name === "Others"
                                                    ? itms?.name +
                                                      ": " +
                                                      itms?.comment
                                                    : itms?.name}
                                                </span>
                                              </>
                                            )}
                                          </div>
                                        );
                                      })}

                                    {itm?.type === "dropdown" &&
                                      itm?.selected && (
                                        <div>
                                          Selected: {itm?.selected?.name}{" "}
                                          {itm?.selected?.text}
                                        </div>
                                      )}

                                    {itm?.type === "rating" && (
                                      <div>{itm?.comment}</div>
                                    )}

                                    {itm?.type === "text" && (
                                      <div>{itm?.comment}</div>
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                        )}

                        {!item?.data?.detailed_review &&
                        user?.role?.role_id === 3 ? (
                          <div>
                            <div className={styles.noUserCard}>
                              <Icons.NoDataIcon />
                              <h5>No Revisions Found</h5>
                            </div>
                          </div>
                        ) : null}

                        {item?.data?.detailed_review &&
                          Object.keys(item?.data?.detailed_review)
                            .map((key) => item?.data?.detailed_review[key])
                            ?.map((itm: any) => {
                              return (
                                <TableRow>
                                  <TableCell>{itm?.label}</TableCell>
                                  <TableCell>
                                    {itm?.type === "rating" ? (
                                      <Rating
                                        name="simple-controlled"
                                        value={itm?.value}
                                        readOnly
                                      />
                                    ) : Number(itm?.option) === 0 ? (
                                      "No"
                                    ) : (
                                      "Yes"
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {itm?.type === "checklist" &&
                                      itm?.options?.map((itms: any) => {
                                        return (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            {itms?.value ? (
                                              <>
                                                <CheckIcon
                                                  style={{ fill: "#9A469B" }}
                                                />{" "}
                                                <span
                                                  style={{ marginLeft: "10px" }}
                                                >
                                                  {itms?.name}
                                                </span>
                                              </>
                                            ) : null}
                                          </div>
                                        );
                                      })}

                                    {itm?.type === "dropdown" &&
                                      itm?.selected && (
                                        <div>
                                          Selected: {itm?.selected?.name}{" "}
                                          {itm?.selected?.text}
                                        </div>
                                      )}

                                    {itm?.type === "rating" && (
                                      <div>{itm?.comment}</div>
                                    )}
                                    {itm?.type === "text" && (
                                      <div>{itm?.comment}</div>
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {totalPage > 1 && (
                    <PaginationComponent
                      totalPages={totalPage}
                      activePage={activePage}
                      setActivePage={setActivePage}
                    />
                  )}
                </Box>
              );
            })
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export default BookRevisions;
